const EnvVar = {
    apiUrl: process.env.REACT_APP_API_URL,
    flamingoApiNs: process.env.REACT_APP_FLAMINGO_API_NAMESPACE,
    wcApiNs: process.env.REACT_APP_WC_API_NAMESPACE,
    wcConsumerKey: process.env.REACT_APP_WC_CONSUMER_KEY,
    wcConsumerSecret: process.env.REACT_APP_WC_CONSUMER_SECRET,
};

export default EnvVar;